(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["download-guide"]) return;
  try {
    
(function () {
  function initSlider(slider) {
    var track = slider.querySelector('[data-dg-track]');
    var slides = slider.querySelectorAll('.dg-slide');
    if (!track || slides.length < 2) return;

    var scope = slider.closest('.dg-phone') || slider;
    var prevBtn = scope.querySelector('[data-dg-prev]');
    var nextBtn = scope.querySelector('[data-dg-next]');
    var dotsWrap = scope.querySelector('[data-dg-dots]');
    var total = slides.length;
    var index = 0;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(slider.getAttribute('data-interval'), 10) || 4000;
    var timer = null;

    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dg-slider-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () {
            goTo(idx);
            restart();
          });
        })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function update() {
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    function goTo(i) {
      index = (i + total) % total;
      update();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function restart() {
      stop();
      start();
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });

    scope.addEventListener('mouseenter', stop);
    scope.addEventListener('mouseleave', start);

    var startX = 0;
    var deltaX = 0;
    var touching = false;

    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      deltaX = 0;
      touching = true;
      stop();
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!touching) return;
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!touching) return;
      touching = false;
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) next();
        else prev();
      }
      start();
    });

    update();
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-dg-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
